import styled from 'styled-components';

const FormFieldContainer = styled.div`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

const Input = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  font-size: 1rem;
  background: ${({ theme }) => theme.colors.white};
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => `${theme.colors.primary}20`};
  }

  &:focus + label,
  &:not(:placeholder-shown) + label {
    transform: translateY(-50%) scale(0.85);
    // background: var(--local-bg, ${({ theme }) => theme.colors.background});
    background: #fff;
    padding: 0 ${({ theme }) => theme.spacing.xs};

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      height: 2px;
      background: var(--local-bg, ${({ theme }) => theme.colors.background});
      transform: translateY(-50%);
      z-index: -1;
    }
  }
`;

const Label = styled.label`
  position: absolute;
  left: ${({ theme }) => theme.spacing.sm};
  top: 0;
  transform: translateY(50%);
  color: ${({ theme }) => theme.colors.text};
  font-size: .9rem;
  transition: transform 0.2s;
  transform-origin: left;
  pointer-events: none;
`;

const FormField = ({ label, id, className, ...props }) => {
  const updateBackground = (el) => {
    if (!el) return;
    const bg = getComputedStyle(el.parentElement).backgroundColor;
    el.style.setProperty('--local-bg', bg);
  };

  return (
    <FormFieldContainer className={className} ref={updateBackground}>
      <Input id={id} placeholder=" " {...props} />
      <Label htmlFor={id}>{label}</Label>
    </FormFieldContainer>
  );
};

export default FormField; 